import * as React from "react";

function SvgIcons8Online(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M5.406 5.406c-5.847 5.848-5.847 15.34 0 21.188l1.407-1.407a12.972 12.972 0 010-18.375zm21.188 0l-1.407 1.407a12.972 12.972 0 010 18.375l1.407 1.406c5.847-5.848 5.847-15.34 0-21.188zM9.625 9.625c-3.508 3.508-3.508 9.242 0 12.75l1.438-1.438a6.955 6.955 0 010-9.875zm12.75 0l-1.438 1.438a6.955 6.955 0 010 9.874l1.438 1.438c3.508-3.508 3.508-9.242 0-12.75zM16 13c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3zm0 2c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Online);
